export enum DialogMessageRole {
  USER = 'user',
  ASSISTANT = 'assistant',
  // сообщение от оператора
  OPERATOR = 'operator',
  // сервисное сообщение, например, чтобы показать пользователю статус оператора
  SERVICE = 'service',
  SUPERVISOR = 'supervisor',
}

export enum MessageType {
  TEXT = 'TEXT',
  VOICE = 'VOICE',
}

export enum CommunicationChannel {
  TEXT_CHAT = 'TEXT_CHAT',
  VOICE_CHAT = 'VOICE_CHAT',
  SIP = 'SIP',
  API = 'API',
}

export type DialogMode = 'operator' | 'expert' | 'supervisor';

export type AudioSegment = { start: number; end: number };

export interface Dialog {
  id: string;
  expert_id: string;
  expert_image_id: string | null;
  expert_name: string;
  user_id: string;
  create_date: string;
  update_date: string;
  messages: DialogMessageDto[];
  file_id: string | null;
  // tts_seconds: number | null;
  // tts_total_char_count: number | null;
  stt_seconds: number | null;
  // total_token_count: number | null;
  // total_cost: number | null;
  audio_segments: AudioSegment[];
  utm: DialogUtm | null;
  mode: DialogMode;
  operator_requested?: boolean;
}

export type DialogUtm = {
  id: string;
  created_at: string | null;
  dialog_id: string | null;
  expert_id: string | null;
  user_id: string | null;

  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
  utm_content: string | null;
  utm_term: string | null;

  ip: string | null;
  geo_country_code: string | null;
  geo_country: string | null;
  geo_city: string | null;
};

export type DialogMessageDto = {
  id: string;
  dialog_id: string;
  user_id: string;
  role: DialogMessageRole;
  message: string;
  create_date: string;
  type: MessageType;
  message_metadata: MessageMetadata | null;
};

export type DialogMessage = Omit<DialogMessageDto, 'dialog_id' | 'user_id' | 'message_metadata'> & {
  message_metadata?: MessageMetadata | null;
  error?: string;
};

export type ServiceSourceItem = {
  source: string;
  text: string;
  score?: number;
  distance?: number;
  raw_meta?: object;
};
export type SourceItem = { filename: string; chunk_text: string; service?: ServiceSourceItem };

export type LangGraphTraceNode = {
  node: string;
  step: number | null;
  output: Record<string, unknown>;
  duration_ms?: number;
};

export type LangGraphMetadata = {
  execution_trace: LangGraphTraceNode[];
  total_duration_ms: number;
  time_to_first_chunk_ms: number;
};

export type MessageMetadata = {
  source: SourceItem[];
  langgraph_metadata: LangGraphMetadata;
};

export type DialogStatus = 'IN_PROGRESS' | 'COMPLETED' | 'SUCCESS';

export type IChatResponse =
  | {
      message: string;
      dialog_status: DialogStatus;
    }
  | { error: string }
  | { message_metadata: MessageMetadata }
  | { llm_switch: true }
  | { suggested_questions: string[] };

export type ChatGenerator = AsyncGenerator<IChatResponse, void, unknown>;

export type TChatLanguage = 'en' | 'ru' | 'es' | 'de' | 'fr' | 'ar';

export type TChatMode = 'expert' | 'operator';
